import { useCallback } from 'react'
import { usePartnerCallbackCreateMutation } from 'domains/connect/api'

export interface PartnerCallbackCreateProps {
  partnerId: string
  orderId: string
  event: string
}

export const usePartnerCallbackCreate = () => {
  const [triggerMutation, { data, loading, error }] = usePartnerCallbackCreateMutation()

  const createPartnerCallback = useCallback(
    (args: PartnerCallbackCreateProps) => triggerMutation({ variables: { ...args } }),
    [triggerMutation]
  )

  const callbackResponse = data && data.partnerCallbackCreate.callbackResponse

  return {
    createPartnerCallback,
    callbackResponse,
    loading,
    error,
  }
}
